const SITE_URL = 'https://zahnarzt-st-toenis.de';

export const getDentistSchema = () => ({
    '@context': 'https://schema.org',
    '@type': 'Dentist',
    name: 'Zahnarztpraxis Roman Boretskyi',
    image: `${SITE_URL}/logo512.png`,
    url: `${SITE_URL}/`,
    telephone: '+492151803208',
    email: 'anmeldung@zahnarzt-st-toenis.de',
    address: {
        '@type': 'PostalAddress',
        streetAddress: 'Kornstraße 53a',
        postalCode: '47918',
        addressLocality: 'Tönisvorst',
        addressCountry: 'DE'
    },
    openingHoursSpecification: [
        {
            '@type': 'OpeningHoursSpecification',
            dayOfWeek: ['Monday', 'Tuesday', 'Wednesday', 'Thursday'],
            opens: '07:30',
            closes: '14:00'
        },
        {
            '@type': 'OpeningHoursSpecification',
            dayOfWeek: ['Monday', 'Tuesday', 'Wednesday', 'Thursday'],
            opens: '14:30',
            closes: '17:00'
        }
    ],
    medicalSpecialty: 'Dentistry'
});

export const getServiceListSchema = (services) => ({
    '@context': 'https://schema.org',
    '@type': 'ItemList',
    itemListElement: services.map((service, index) => ({
        '@type': 'ListItem',
        position: index + 1,
        item: {
            '@type': 'Service',
            name: service.title,
            description: service.description,
            provider: {
                '@type': 'Dentist',
                name: 'Zahnarztpraxis Roman Boretskyi'
            },
            areaServed: {
                '@type': 'City',
                name: 'Tönisvorst'
            }
        }
    }))
});

export const getJobPostingSchema = (job, email) => ({
    '@context': 'https://schema.org',
    '@type': 'JobPosting',
    title: job.title,
    description: [
        ...job.intro.map((paragraph) => `<p>${paragraph}</p>`),
        '<p><strong>Das erwartet dich bei uns:</strong></p>',
        `<ul>${job.benefits.map((b) => `<li>${b.title}: ${b.text}</li>`).join('')}</ul>`,
        '<p><strong>Das bringst du mit:</strong></p>',
        `<ul>${job.requirements.map((r) => `<li>${r}</li>`).join('')}</ul>`,
        `<p>Bewerbung an ${email}</p>`
    ].join(''),
    datePosted: job.datePosted,
    employmentType: job.employmentType,
    hiringOrganization: {
        '@type': 'Organization',
        name: 'Zahnarztpraxis Roman Boretskyi',
        sameAs: `${SITE_URL}/`,
        logo: `${SITE_URL}/logo512.png`
    },
    jobLocation: {
        '@type': 'Place',
        address: {
            '@type': 'PostalAddress',
            streetAddress: 'Kornstraße 53a',
            postalCode: '47918',
            addressLocality: 'Tönisvorst',
            addressRegion: 'NRW',
            addressCountry: 'DE'
        }
    },
    directApply: false
});
